import React from 'react';

import { pythonTaskApi } from '~/client/services';

interface Props {
  taskId: string;
  pollingInterval?: number;
  onComplete?: (data: any) => void;
}

const ShowProgress: React.FC<Props> = ({
  taskId,
  pollingInterval,
  onComplete,
}) => {
  const [taskActive, setTaskActive] = React.useState(true);
  const onCompleteRef = React.useRef(onComplete);

  // Keep ref updated
  React.useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]);

  const { data } = pythonTaskApi.useStatusQuery(taskId, {
    pollingInterval: taskActive ? pollingInterval : undefined,
    skip: !taskActive,
  });
  const [cancelTask] = pythonTaskApi.useCancelMutation();

  // Use useMemo to derive task completion state without triggering effects
  const isComplete = React.useMemo(() => {
    if (data) {
      const { task, state } = data;
      switch (state) {
        case 'PENDING':
        case 'STARTED':
        case 'RETRY':
        case 'PROGRESS':
          break;

        case 'SUCCESS':
        case 'FAILURE':
        case 'REVOKED':
          if (taskActive) {
            setTaskActive(false);
            onCompleteRef.current?.({
              state,
              ...task,
            });
          }
          return true;
      }
    }
    return false;
  }, [data, taskActive]);

  if (!taskActive) {
    return null;
  }

  return (
    <div>
      <div>Task Running...</div>
      <pre>{JSON.stringify(data, null, 2)}</pre>
      <p />
      <button
        onClick={() => {
          cancelTask(taskId);
        }}
      >
        Cancel Task
      </button>
      <p />
    </div>
  );
};

export default ShowProgress;
